// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"a5d9707e","316":"f20e2dc2","859":"e8c81cfd"}[chunkId] + ".chunk.js";
};